import * as React from 'react';
import { Avatar } from './Avatar';
import { colors } from '../colors/color';
import { ArticleImportanceVariant, txt } from '../../txt';


type ImportanceAvatarProps = {
    mode?:ArticleImportanceVariant,
    importance?: 'low' | 'medium' | 'high',
    fontSize?: string,
    size?: string,
    text?: string
};

export function ImportanceAvatar ({ mode, importance, size, fontSize, text }: ImportanceAvatarProps): JSX.Element
{
    const color = getImportanceOvalColor(importance);

    const tooltip = txt.articleChangeImportanceText(mode || 'change', importance);
    return (
        <Avatar
            toolTip={tooltip ? <div>{tooltip}</div> : undefined}
            size={size || '16px'}
            backgroundColor={color}>

            <span style={{ fontSize }}>{text || undefined}</span>

        </Avatar>
    );
}

export function getImportanceOvalColor (importance?: 'low' | 'medium' | 'high'): string
{
    if (importance === 'high')
        return colors.importance.high;
    else if (importance === 'medium')
        return colors.importance.medium;
    else if (importance === 'low')
        return colors.importance.low;

    return colors.icon.passive;
}